<template>
  <Datepicker
    @input="input"
    v-model="currentDate"
    :format="DatePickerFormat"
    :language="language"
    :disabled="disabled"
    :disabledDates="disabledDates"
    :clear-button="true"
    clear-button-icon="fa fa-times"
    name="datepicker"
    input-class="input-class">
  </Datepicker>
</template>

<script>
import Datepicker from 'vuejs-datepicker'

export default {
  props: {
    disabledDates: { type: Object, default: function () { return {} } },
    defaultDate: Date,
    format: { type: String, default: 'yyyy-MM-dd' },
    disabled: { type: Boolean, default: false },
    value: {
      type: String,
      default: '0000-00-00'
    }
  },
  data () {
    return {
      currentDate: this.defaultDate ? this.defaultDate : this.value,
      DatePickerFormat: 'yyyy-MM-dd',
      language: {
        language: 'Korean',
        months: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
        monthsAbbr: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
        days: ['일', '월', '화', '수', '목', '금', '토'],
        rtl: false,
        ymd: true,
        yearSuffix: '년'
      }
    }
  },
  components: {
    Datepicker
  },
  watch: {
    value (newValue) {
      this.currentDate = newValue
    }
  },
  methods: {
    input (date) {
      this.$emit('input', this.$dayjs(date).format('YYYY-MM-DD'))
    },
    // setDate (date) {
    //   this.currentDate = date
    // }
  }
}
</script>

<style>
.vdp-datepicker .input-class {
  width: 100%;
  height: calc(1.5em + .5rem + 2px);
  padding: .25rem .5rem;
  font-size: .875rem;
  min-height: 32px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.vdp-datepicker .vdp-datepicker__clear-button {
  position: absolute;
  right: 10px;
  top: 9px
}
</style>
